import { render, staticRenderFns } from "./AccessListSelect.vue?vue&type=template&id=3d954f33"
import script from "./AccessListSelect.vue?vue&type=script&lang=js"
export * from "./AccessListSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports